import { computed, defineComponent } from 'vue';
import PropTypes from '../_util/vue-types';
import useConfigInject from '../_util/hooks/useConfigInject';
export default defineComponent({
    name: 'AInputGroup',
    props: {
        prefixCls: PropTypes.string,
        size: { type: String },
        compact: PropTypes.looseBool,
        onMouseenter: { type: Function },
        onMouseleave: { type: Function },
        onFocus: { type: Function },
        onBlur: { type: Function },
    },
    setup(props, { slots }) {
        const { prefixCls, direction } = useConfigInject('input-group', props);
        const cls = computed(() => {
            const pre = prefixCls.value;
            return {
                [`${pre}`]: true,
                [`${pre}-lg`]: props.size === 'large',
                [`${pre}-sm`]: props.size === 'small',
                [`${pre}-compact`]: props.compact,
                [`${pre}-rtl`]: direction.value === 'rtl',
            };
        });
        return () => {
            var _a;
            return (<span class={cls.value} onMouseenter={props.onMouseEnter} onMouseleave={props.onMouseLeave} onFocus={props.onFocus} onBlur={props.onBlur}>
          {(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)}
        </span>);
        };
    },
});
